import { render, staticRenderFns } from "./FormNodeGiaPha.vue?vue&type=template&id=4da1b76a&scoped=true&"
import script from "./FormNodeGiaPha.vue?vue&type=script&lang=js&"
export * from "./FormNodeGiaPha.vue?vue&type=script&lang=js&"
import style0 from "./FormNodeGiaPha.vue?vue&type=style&index=0&id=4da1b76a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da1b76a",
  null
  
)

export default component.exports